var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "carteira-analise" },
    [
      _c(
        "ConditionalTeleport",
        { attrs: { to: "page-header-actions", routes: _vm.moduleRoutes } },
        [
          _c("BasePageHeader", {
            scopedSlots: _vm._u([
              {
                key: "filter",
                fn: function() {
                  return [
                    _c("WalletFilters", {
                      attrs: {
                        fields: _vm.walletFilterFields,
                        "enabled-field-keys": _vm.menuWalletFilterKeys,
                        disabled: _vm.isLoadingData
                      },
                      on: { filter: _vm.handleFilterApply }
                    })
                  ]
                },
                proxy: true
              },
              {
                key: "actions",
                fn: function() {
                  return [
                    _vm.showReportActions
                      ? _c("BaseSplitButton", {
                          attrs: {
                            label: "Relatórios",
                            leading: "document-text",
                            items: _vm.reportActions,
                            loading: _vm.isLoadingData
                          },
                          on: {
                            click: _vm.openSelectModelPDF,
                            select: _vm.onReportAction
                          }
                        })
                      : _vm._e()
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _vm.walletScope.ativo
        ? _c("WalletAlerts", {
            staticClass: "mt-5",
            attrs: { context: _vm.walletAlertsContext },
            on: { action: _vm.onWalletAlertAction }
          })
        : _vm._e(),
      _vm.showWalletEmptyState
        ? _c("WalletEmptyState", {
            attrs: {
              loading: _vm.isLoadingData,
              "client-not-selected": _vm.clientNotSelected,
              "clients-loading": _vm.loadingClients,
              "has-selected-client": _vm.hasSelectedClient,
              "has-access": _vm.hasAcess,
              "has-clients": _vm.hasClients,
              "has-assets": !_vm.isEmpty,
              "has-client": _vm.hasClient,
              "is-client-user": _vm.isClient,
              "view-tipo": _vm.walletScope.viewTipo,
              grupo: _vm.walletScope.grupo
            },
            on: {
              "select-client": _vm.openSelectClientModal,
              "open-new-client": _vm.openRegisterClientModal,
              "new-group": _vm.abrirNovoGrupo,
              "new-asset": _vm.openRegisterAssetModal,
              "import-assets": _vm.openImportExtratoModal
            }
          })
        : [
            _vm.isLoadingData || !_vm.isEmpty
              ? _c(
                  "div",
                  {
                    ref: "pdf-content",
                    staticClass: "mt-5",
                    attrs: { id: "pdf-content" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "print-only print-break-after align-items-center"
                      },
                      [
                        _c(
                          "FeedbackWrapper",
                          {
                            attrs: {
                              loading: _vm.walletAnalysisLoading,
                              minHeight: 280,
                              message: _vm.noDataMessage,
                              noData: !_vm.hasIndicatorsData,
                              bordered: ""
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "carteira-analise__card az-card-bordered"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-space-between mb-3"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "carteira-analise__title az-ds-card-title"
                                      },
                                      [_vm._v(" Indicadores ")]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "d-flex align-center" },
                                      [
                                        _vm.clienteBenchmarkMeta
                                          ? _c(
                                              "v-tooltip",
                                              {
                                                attrs: {
                                                  bottom: "",
                                                  "max-width": "260"
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function(ref) {
                                                        var on = ref.on
                                                        return [
                                                          _c(
                                                            "div",
                                                            _vm._g(
                                                              {
                                                                staticClass:
                                                                  "d-inline-flex"
                                                              },
                                                              on
                                                            ),
                                                            [
                                                              _vm.benchmarks_selecionados.includes(
                                                                _vm.CLIENT_BENCHMARK_KEY
                                                              )
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "d-inline-flex align-center mr-2"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "BaseStatus",
                                                                        {
                                                                          attrs: {
                                                                            text:
                                                                              "",
                                                                            "preserve-case":
                                                                              "",
                                                                            content:
                                                                              _vm
                                                                                .clienteBenchmarkMeta
                                                                                .label,
                                                                            color:
                                                                              _vm.BENCHMARK_PERSONALIZADO_COLOR
                                                                          }
                                                                        }
                                                                      ),
                                                                      _c(
                                                                        "icon-svg",
                                                                        {
                                                                          staticClass:
                                                                            "carteira-analise__remove-benchmark ml-1",
                                                                          attrs: {
                                                                            name:
                                                                              "mdi-close",
                                                                            size: 16,
                                                                            color:
                                                                              "var(--secondary)",
                                                                            role:
                                                                              "button",
                                                                            tabindex:
                                                                              "0",
                                                                            "aria-label":
                                                                              "Remover benchmark do cliente"
                                                                          },
                                                                          on: {
                                                                            click:
                                                                              _vm.removeClienteBenchmarkFromIndicadores,
                                                                            keydown: [
                                                                              function(
                                                                                $event
                                                                              ) {
                                                                                if (
                                                                                  !$event.type.indexOf(
                                                                                    "key"
                                                                                  ) &&
                                                                                  _vm._k(
                                                                                    $event.keyCode,
                                                                                    "enter",
                                                                                    13,
                                                                                    $event.key,
                                                                                    "Enter"
                                                                                  )
                                                                                ) {
                                                                                  return null
                                                                                }
                                                                                return _vm.removeClienteBenchmarkFromIndicadores(
                                                                                  $event
                                                                                )
                                                                              },
                                                                              function(
                                                                                $event
                                                                              ) {
                                                                                if (
                                                                                  !$event.type.indexOf(
                                                                                    "key"
                                                                                  ) &&
                                                                                  _vm._k(
                                                                                    $event.keyCode,
                                                                                    "space",
                                                                                    32,
                                                                                    $event.key,
                                                                                    [
                                                                                      " ",
                                                                                      "Spacebar"
                                                                                    ]
                                                                                  )
                                                                                ) {
                                                                                  return null
                                                                                }
                                                                                $event.preventDefault()
                                                                                return _vm.removeClienteBenchmarkFromIndicadores(
                                                                                  $event
                                                                                )
                                                                              }
                                                                            ]
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                : _c(
                                                                    "BaseButton",
                                                                    {
                                                                      staticClass:
                                                                        "mr-2",
                                                                      attrs: {
                                                                        secondary:
                                                                          "",
                                                                        "x-small":
                                                                          ""
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          _vm.addClienteBenchmarkToIndicadores
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " + " +
                                                                          _vm._s(
                                                                            _vm
                                                                              .clienteBenchmarkMeta
                                                                              .label
                                                                          ) +
                                                                          " "
                                                                      )
                                                                    ]
                                                                  )
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  false,
                                                  263552675
                                                )
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    "Benchmark padrão deste cliente. Para alterar, edite os dados cadastrais do cliente."
                                                  )
                                                ])
                                              ]
                                            )
                                          : _vm._e(),
                                        _c("AutocompleteMany", {
                                          staticStyle: { "max-width": "275px" },
                                          attrs: {
                                            items: _vm.BENCHMARKS,
                                            text: "nome",
                                            label: "Selecione os indicadores",
                                            multiple: true,
                                            selected:
                                              _vm.benchmarks_selecionados,
                                            "selected-items-to-show": 2
                                          },
                                          on: {
                                            "update:selected": [
                                              function($event) {
                                                _vm.benchmarks_selecionados = $event
                                              },
                                              function($event) {
                                                _vm.benchmark_statistics_change = true
                                              }
                                            ]
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _c("TabelaRentBenchmark", {
                                  attrs: {
                                    "rentabilidades-all":
                                      _vm.rentBenchmarkTable.rentabilidadesAll,
                                    benchmarksSelecionados:
                                      _vm.benchmarks_selecionados,
                                    "rentabilidades-benchmarks":
                                      _vm.rentBenchmarkTable
                                        .rentabilidadesBenchmarks,
                                    clienteBenchmarkMeta:
                                      _vm.clienteBenchmarkMeta
                                  }
                                }),
                                _vm.dataFimReferencia
                                  ? _c(
                                      "p",
                                      {
                                        staticClass:
                                          "carteira-analise__text-base"
                                      },
                                      [
                                        _vm._v(
                                          " * Data base para a rentabilidade: " +
                                            _vm._s(_vm.dataFimReferencia) +
                                            " "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "mt-5" },
                          [
                            _c("AlocacaoEstrategica", {
                              attrs: {
                                loading: _vm.walletAnalysisLoading,
                                valuesChart: _vm.alocacaoChartValues,
                                optionsChat: _vm.alocacaoChartOpts,
                                colorsByLabel: _vm.allocationColorsByLabel,
                                investmentType: _vm.displayInvestmentTypeFilter,
                                suggestedValues: _vm.suggestedAllocations
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "info-adicional",
                                    fn: function() {
                                      return [
                                        _vm.dataFimReferencia
                                          ? _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "carteira-analise__text-base"
                                              },
                                              [
                                                _vm._v(
                                                  " * Data base para a composição estratégica: " +
                                                    _vm._s(
                                                      _vm.dataFimReferencia
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                456046384
                              )
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "mt-5 print-grafico-linha" },
                          [
                            _c("PortfolioBenchmark", {
                              attrs: {
                                data: _vm.rentabilityChart,
                                loading: _vm.walletAnalysisLoading,
                                benchmarks: _vm.BENCHMARKS,
                                "cliente-benchmark-meta":
                                  _vm.clienteBenchmarkMeta,
                                "available-benchmark-names":
                                  _vm.availableBenchmarkNames,
                                "show-add-benchmark": !_vm.isClient,
                                "empty-message": _vm.noDataMessage
                              },
                              on: {
                                change: function($event) {
                                  _vm.benchmark_graph_changed = true
                                },
                                "add-benchmark": _vm.openBenchmark,
                                reset: _vm.resetGraphBenchmarks
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "footer",
                                    fn: function() {
                                      return [
                                        _vm.dataFimReferencia
                                          ? _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "carteira-analise__text-base"
                                              },
                                              [
                                                _vm._v(
                                                  " * Data base para o portfólio: " +
                                                    _vm._s(
                                                      _vm.dataFimReferencia
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                3196270555
                              ),
                              model: {
                                value: _vm.benchmarks_selecionados_grafico,
                                callback: function($$v) {
                                  _vm.benchmarks_selecionados_grafico = $$v
                                },
                                expression: "benchmarks_selecionados_grafico"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      { staticClass: "mt-2" },
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12", lg: "6" } },
                          [
                            _c("Distribuicao", {
                              attrs: {
                                distribuicaoPor: "Instituição",
                                data: _vm.institutionDistributionData,
                                loading: _vm.walletAnalysisLoading,
                                investmentType: _vm.displayInvestmentTypeFilter,
                                minHeight: 385
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "12", lg: "6" } },
                          [
                            _c("LiquidezChart", {
                              staticClass: "print-only print-break-after",
                              attrs: {
                                liquidezData: _vm.liquidezChartData,
                                loading: _vm.walletAnalysisLoading,
                                "empty-message": _vm.noDataMessage,
                                "min-height": 385
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "mt-2 print-only print-break-before align-items-center"
                      },
                      [
                        _c(
                          "FeedbackWrapper",
                          {
                            attrs: {
                              loading: _vm.isLoadingData,
                              minHeight: 300,
                              message: _vm.noDataMessage,
                              noData:
                                !_vm.walletScope.ativo ||
                                (!Object.keys(_vm.retornoMensalTable).length &&
                                  _vm.isEmpty),
                              bordered: ""
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "carteira-analise__card az-card-bordered"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "carteira-analise__title az-ds-card-title"
                                  },
                                  [_vm._v(" Retornos mensais ")]
                                ),
                                _c("div", { staticClass: "my-3" }, [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "margin-bottom": "60px",
                                        "max-width": "100%",
                                        overflow: "auto"
                                      }
                                    },
                                    [
                                      _c("TabelaRetornoMensais", {
                                        attrs: {
                                          "retorno-mensal":
                                            _vm.retornoMensalTable,
                                          "cliente-benchmark-meta":
                                            _vm.clienteBenchmarkMeta
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "FeedbackWrapper",
                      {
                        staticClass: "mt-5",
                        attrs: {
                          loading: _vm.walletAnalysisLoading,
                          minHeight: 385,
                          message: _vm.noDataMessage,
                          noData: !Object.entries(_vm.assetsAnalysisData)
                            .length,
                          bordered: ""
                        }
                      },
                      [
                        _c("AssetsAnalysisTable", {
                          attrs: {
                            lazyMode: "",
                            "show-owner-column":
                              _vm.walletScope.tipo === "grupo",
                            assets: _vm.assetsAnalysisData,
                            "group-assets": _vm.groupAssets,
                            "loading-assets": _vm.loadingAssets,
                            "class-benchmark-map": _vm.classBenchmarkMap,
                            "data-reference-end": _vm.dataFimReferencia,
                            "hide-group-assets-toggle": ""
                          },
                          on: {
                            "update:groupAssets": function($event) {
                              _vm.groupAssets = $event
                            },
                            "update:group-assets": function($event) {
                              _vm.groupAssets = $event
                            },
                            "reload-assets": _vm.reloadAssets
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
      _c("ConsolidatorSelectClient"),
      _c("InputByType", {
        staticStyle: { display: "none" },
        attrs: { type: "file", "id-input": "compare-pdf-input" },
        on: { "add-file": _vm.handleComparePdfFile }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }